import { IEntity } from './entity.interface';

export interface IEntityAncestors
  extends Pick<IEntity, 'entityUid' | 'name' | 'entityType' | 'friendlyName'> {
  parent?: IEntityAncestors;
}
